import { makeObservable, observable, action } from 'mobx';

class WarningDialogStore {
  isOpen: boolean = false;
  message: string = '';

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      message: observable,
      open: action,
      close: action
    });
  }

  open = (message: string) => {
    this.message = message;
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
    this.message = '';
  };
}

const singleton = new WarningDialogStore();
export default singleton;
